import { Grid, Input, Span } from 'components'
import { useMovement } from 'hooks'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

const Tipo = () => {
  const { movState } = useMovement()
  return (
    <>
      <Span
        marginTop={SPACING.spacing10}
        marginBottom={SPACING.spacing20}
        text="TIPO"
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
        color={COLORS.black}
      />
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        gridGap="1rem"
        padding={`0 0 ${SPACING.spacing30}`}
      >
        <Input
          value={movState?.visaoTotal?.qtClt}
          label="CLT"
          placeholder="CLT"
          formValue="qtClt"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtSocio}
          label="Sócio"
          placeholder="Sócio"
          formValue="qtSocio"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtCooperado}
          label="Cooperado"
          placeholder="Cooperado"
          formValue="qtCooperado"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtEstrangeiro}
          label="Estrangeiro"
          placeholder="Estrangeiro"
          formValue="qtEstrangeiro"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtEstagiario}
          label="Estagiário"
          placeholder="Estagiário"
          formValue="qtEstagiario"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtAutonomo}
          label="Autônomo"
          placeholder="Autônomo"
          formValue="qtAutonomo"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtMei}
          label="MEI"
          placeholder="MEI"
          formValue="qtMei"
          disabled
        />
      </Grid>
    </>
  )
}

export default Tipo
